module.exports = __webpack_public_path__ + "static/img/culture_one.28c1b74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/corporateCulture/culture_one.png
// module id = DX5X
// module chunks = 1